import React, { Component } from "react";
import { connect } from "react-redux";
import { browserHistory } from 'react-router';
import _ from "lodash";
import moment from "moment";

import {
	saveBackOrders,
	saveBulkOrdersHold,
	addToCart,
	checkForPrices,
	deleteOrderDetails,
	saveBackupCartItem,
	saveBackOrderCartItem,
	exportOrdersDetails,
} from "../../../redux/actions";

import { DATE_TIME_FORMAT } from '../../common/messageConstants';

import PriceSourceOverlayDialog from "../../dialogs/priceSourceOverlayDialog";
import ConfirmCancelLineOverlayDialog from '../../dialogs/confirmCancelLineOverlayDialog';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import BackOrderFilters from './backOrderFilterComponent';

class BackOrders extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showGenericOverlayDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
			batchSize: 10,

			showPriceSourceOverlayDialog: false,
			selectedPriceSource: null,
			orderDate: null,
			isSelectAll: false,
			errorMessage: null,
			errorList: [],
			points: 0.00,
			selectedPoints:0.00,
			filter: {
				shipToAddress: false,
				salesAgreement: false,
			},
			showConfirmCancelLineOverlayDialog: false,
		};
		this.handleSelectAll = this.handleSelectAll.bind(this);
		this.updateOrderPoints = this.updateOrderPoints.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
	}

	sortByKey(array, key) {
		return array.sort(function(a, b) {
			var x = a[key];
			var y = b[key];
			return x < y ? -1 : x > y ? 1 : 0;
		});
	}

	componentWillReceiveProps(nextProps) {
		const self = this;
			// { backOrders, bulkOrdersHold } = self.props.state.order;
		if(self.props.state.user.selectedAddress && self.props.state.user.selectedAddress !== nextProps.state.user.selectedAddress) {
			self.updateOrderPoints();
		}
		if(self.props.state.user.selectedPriceSource.AGREEMENT_NUMBER !== nextProps.state.user.selectedPriceSource.AGREEMENT_NUMBER) {
			setTimeout(self.updateOrderPoints, 1000);
		}
	}

	componentWillMount() {
		const self = this,
			{ backOrders, bulkOrdersHold } = self.props.state.order;
		if(backOrders && backOrders.responseObject && bulkOrdersHold && bulkOrdersHold.responseObject) {
			self.fetchOrderDetails();
		} else {
			self.props.resetParallelCallsOrderDetails();
			self.props.checkForBackOrders(self.props.getSelectedAccountNumber(), true, response => {
				self.setState({
					backOrderCallCompleted: true
				}, () => {
					self.callBackAfterCallsCompleted();
				});
			});
			self.props.checkForBulkOrdersHold(self.props.getSelectedAccountNumber(), true, response => {
				self.setState({
					bulkOrderHoldCallCompleted: true
				}, () => {
					self.callBackAfterCallsCompleted();
				});
			});
		}
	}

	callBackAfterCallsCompleted() {
		const self = this;
		const { backOrderCallCompleted, bulkOrderHoldCallCompleted } = self.state;
		if(backOrderCallCompleted && bulkOrderHoldCallCompleted) {
			self.fetchOrderDetails();
		}
	}

	componentWillUnmount() {
		this.handleSelectAll({ target: { checked: false } });
	}

	handleExport(event) {
        event.preventDefault();
        const self = this;
		let exportErrorMessage = "";
        self.setState({
			errorMessage:"",
			exportErrorMessage:""
        });
        
        const backOrders = JSON.parse(JSON.stringify(self.props.state.order.backOrders));
        const bulkOrdersHold = JSON.parse(JSON.stringify(self.props.state.order.bulkOrdersHold));
        let formError = false;
        const errorList = [];
        const payload = [];
        if(backOrders.responseObject.length > 0) {
        backOrders.responseObject.forEach((item, index) => {
            let shipToAdress = item.orderHeader.parties.party.filter(party=>party.purpose === "SHIP_TO");
            item.orderDetail.orderLine.forEach((i, index) => {
                if(i.orderedQtyError || i.orderedQtyRequiredError) {
                    formError = true;
                }
                
                if (i.selected && self.checkIfAnyFilterSatisfied(item, i)) {
                    payload.push({
                        accountNumber : self.props.state.user.accountDetail.responseObject[0].ACCOUNTNUMBER,
                        orderNumber : item.orderHeader.orderNumber,
                        orderDate : i.keepOriginalPrice === 'Y' ? self.props.pickTheDateFromString(i.linePricingDate) : '',
                        warehouseCode : i.warehouse && i.warehouse.warehouseCode,
                        shipToAddress1 : shipToAdress[0].party.partySites.site[0].siteLocation.locationId.split("|")[0] || " ",
                        shipToCity : shipToAdress[0].party.partySites.site[0].siteLocation.locationId.split("|")[4] || " ",
                        shipToState : shipToAdress[0].party.partySites.site[0].siteLocation.locationId.split("|")[6] || " ",
                        product : i.item,
                        po : i.lineCustomerPONumber,
                        pointsPerUnit : i.pointValue,
                        qtyOrdered : i.orderedQty,
                        qtyReserved : i.reservedQty,
                        originalPrice : i.itemPrice.salesPrice,
                        priceDate : i.linePricingDate,
						salesAgreementNumber:item.orderHeader.salesAgreement.agreementNumber|| "",
                        salesAgreement : item.orderHeader.salesAgreement.agreementName || "",
                        backOrderExpDate : i.lineDate
                    });
                   
                }
            });

        });

    }
    if(bulkOrdersHold.responseObject.length > 0) {
        bulkOrdersHold.responseObject.forEach((item, index) => {
            let shipToAdress = item.orderHeader.parties.party.filter(party=>party.purpose === "SHIP_TO");
            item.orderDetail.orderLine.forEach((i, index) => {
                if(i.orderedQtyError || i.orderedQtyRequiredError) {
                    formError = true;
                }
                
                if (i.selected && self.checkIfAnyFilterSatisfied(item, i)) {
                    payload.push({
                        accountNumber : self.props.state.user.accountDetail.responseObject[0].ACCOUNTNUMBER,
                        orderNumber : item.orderHeader.orderNumber,
                        orderDate : i.keepOriginalPrice === 'Y' ? self.props.pickTheDateFromString(i.linePricingDate) : '',
                        warehouseCode : item.orderHeader.warehouse.warehouseCode,
                        shipToAddress1 : shipToAdress[0].party.partySites.site[0].siteLocation.locationId.split("|")[0] || " ",
                        shipToCity : shipToAdress[0].party.partySites.site[0].siteLocation.locationId.split("|")[4] || " ",
                        shipToState : shipToAdress[0].party.partySites.site[0].siteLocation.locationId.split("|")[6] || " ",
                        product : i.item,
                        po : i.lineCustomerPONumber,
                        pointsPerUnit : i.pointValue,
                        qtyOrdered : i.orderedQty,
                        qtyReserved : i.reservedQty,
                        originalPrice : i.itemPrice.salesPrice,
                        priceDate : i.linePricingDate,
						salesAgreementNumber:item.orderHeader.salesAgreement.agreementNumber|| "",
                        salesAgreement : item.orderHeader.salesAgreement.agreementName || "",
                        backOrderExpDate : i.lineDate
                    });
        
                }
            });

        });
    }   
		if(payload.length === 0){
			exportErrorMessage = "Please select the orders to export."
			self.setState({exportErrorMessage:"Please select the orders to export."})
		}
		if(exportErrorMessage === ""){
			self.props.exportOrdersDetails(payload, 'requestType=backOrderExport&accountNumber=' + self.props.state.user.accountDetail.responseObject[0].ACCOUNTNUMBER, (response) => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					window.open(response.responseObject);
				}
			});
		}
      
    }


	fetchOrderDetails() {
		const self = this,
			{ backOrders, bulkOrdersHold } = self.props.state.order;
		const skuListForPim = [];
		backOrders && backOrders.responseObject && backOrders.responseObject.forEach(item => {
			if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
				item.orderDetail.orderLine.forEach((i, index) => {
					if (i.lineStatus.toLowerCase() !== 'cancelled' && self.props.isBackOrderHold(i) && i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
						i.backOrdNotifications.backOrdNotification = self.sortByKey(i.backOrdNotifications.backOrdNotification, "notificationDate");
						if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y") {
							if(skuListForPim.indexOf(i.item) === -1) {
								skuListForPim.push(i.item);
							}
							i.keepOriginalPrice = "Y";
							i.keepOriginalPO = "Y";
							i.selected = self.state.isSelectAll;
							i.originalOrderQuantity = i.orderedQty;
							let lineDate = null;
							i.backOrdNotifications.backOrdNotification.forEach(notification => {
								if (lineDate === null || moment(lineDate).isAfter(moment(notification.notificationDate))) {
									lineDate = notification.notificationDate;
								}
							});
							if(lineDate) {
								lineDate = moment(lineDate, "YYYY-MM-DD h:mm:ss a").add(7, "days").format("MM/DD/YYYY");
							}
							i.lineDate = lineDate;
						}
					}
				});
			}
		});
		let isThereAnyBulkOrderHold = false;
		bulkOrdersHold && bulkOrdersHold.responseObject && bulkOrdersHold.responseObject.forEach(item => {
			if (self.props.isBulkOrderHold(item.orderHeader, item.orderDetail.orderLine)) {
				if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
					item.orderDetail.orderLine.forEach((i, index) => {
						if (i.lineStatus.toLowerCase() !== 'cancelled' && i.reservedQty) {
							if(skuListForPim.indexOf(i.item) === -1) {
								skuListForPim.push(i.item);
							}
							i.keepOriginalPrice = "Y";
							i.keepOriginalPO = "Y";
							i.selected = self.state.isSelectAll;
							i.originalReservedQty = i.reservedQty;
							isThereAnyBulkOrderHold = true;
						}
					});
				}
			}
		});
		self.setState({
			isThereAnyBulkOrderHold
		}, () => {
			// Update store with sorted data
			self.props.saveBackOrders(null);
			self.props.saveBackOrders(backOrders);
			self.props.saveBulkOrdersHold(null);
			self.props.saveBulkOrdersHold(bulkOrdersHold);
			// self.props.getOrderDetailsInParallelBatches(orderNumbers);
			let attributeName = "geego_top_load";
			self.props.getOrgAttributesByAttributeName("Top Load Indicator", (resp) => {
				if(!resp) {
					attributeName = "geego_no_top_load";
				}
				self.props.getPimDataInBatches(skuListForPim, 100, responseObject => {
					self.setState({
						pimResponseObject: responseObject,
						attributeName
					}, () => {
						self.updateOrderPoints();
					});
				});
			});
		});
	}

	updateOrderPoints() {
		const self = this,
			{ backOrders, bulkOrdersHold } = self.props.state.order,
			{ pimResponseObject: responseObject, attributeName } = self.state;
		let points = 0.0;
		backOrders.responseObject.forEach(item => {
			if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
				item.orderDetail.orderLine.forEach((i, index) => {
					if (i.lineStatus.toLowerCase() !== 'cancelled' && self.props.isBackOrderHold(i) && i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
						i.backOrdNotifications.backOrdNotification = self.sortByKey(i.backOrdNotifications.backOrdNotification, "notificationDate");
						if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y" && self.checkIfAnyFilterSatisfied(item, i)) {
							const pimItemData = responseObject && _.find(responseObject, {item_number: i.item});
							if(pimItemData) {
								points += (pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * (i.originalOrderQuantity)) : 0.00);
								i.pointValue = (pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00);
							}
						}
					}
				});
			}
		});
		self.props.saveBackOrders(backOrders);
		bulkOrdersHold.responseObject.forEach(item => {
			if (self.props.isBulkOrderHold(item.orderHeader, item.orderDetail.orderLine)) {
				if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
					item.orderDetail.orderLine.forEach((i, index) => {
						if (i.lineStatus.toLowerCase() !== 'cancelled' && i.reservedQty && self.checkIfAnyFilterSatisfied(item, i)) {
							const pimItemData = responseObject && _.find(responseObject, {item_number: i.item});
							if(pimItemData) {
								points += (pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * (i.originalReservedQty)) : 0.00);
								i.pointValue = (pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00);
							}
						}
					});
				}
			}
		});
		self.props.saveBulkOrdersHold(bulkOrdersHold);
		self.setState({
			points: parseFloat(points).toFixed(2),
		});
	}
	updateOrderPointsFilter() {
		const self = this,
			{ backOrders, bulkOrdersHold } = self.props.state.order,
			{ pimResponseObject: responseObject, attributeName } = self.state;
		let points = 0.0;
		let selectPointsLocal =0.0;
		backOrders.responseObject.forEach(item => {
			if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
				item.orderDetail.orderLine.forEach((i, index) => {
					if (i.lineStatus.toLowerCase() !== 'cancelled' && self.props.isBackOrderHold(i) && i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
						i.backOrdNotifications.backOrdNotification = self.sortByKey(i.backOrdNotifications.backOrdNotification, "notificationDate");
						if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y" && self.checkIfAnyFilterSatisfied(item, i)) {
							const pimItemData = responseObject && _.find(responseObject, {item_number: i.item});
							if(pimItemData) {
								points += (pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * (i.originalOrderQuantity)) : 0.00);
								i.pointValue = (pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00);
								if(i.selected){
									selectPointsLocal += (pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * (i.originalOrderQuantity)) : 0.00);
								}
							}
						}
					}
				});
			}
		});
		self.props.saveBackOrders(backOrders);
		bulkOrdersHold.responseObject.forEach(item => {
			if (self.props.isBulkOrderHold(item.orderHeader, item.orderDetail.orderLine)) {
				if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
					item.orderDetail.orderLine.forEach((i, index) => {
						if (i.lineStatus.toLowerCase() !== 'cancelled' && i.reservedQty && self.checkIfAnyFilterSatisfied(item, i)) {
							const pimItemData = responseObject && _.find(responseObject, {item_number: i.item});
							if(pimItemData) {
								points += (pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * (i.originalReservedQty)) : 0.00);
								i.pointValue = (pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00);
								if(i.selected){
									selectPointsLocal += (pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * (i.originalOrderQuantity)) : 0.00);
								}
							}
						}
					});
				}
			}
		});
		self.props.saveBulkOrdersHold(bulkOrdersHold);
		self.setState({
			points: parseFloat(points).toFixed(2),
			selectedPoints:  parseFloat(selectPointsLocal).toFixed(2)
		});

	}

	handleDialog(dialog, flag, e) {
		this.setState({
			["show" + dialog]: false,
		}, () => {
			this.setState({
				["show" + dialog]: flag,
			});
		});
	}

	handleAddToCart(itemx, whichObject, e) {
		const self = this;
		const payload = JSON.parse(JSON.stringify(self.props.state.order[whichObject]));
		payload.responseObject.forEach((item, index) => {
			item.orderDetail.orderLine.forEach((i, index) => {
				if (i.orderLineId === itemx) {
					i.selected = e.target.checked;
					if( e.target.checked){
						let points = parseFloat(this.state.selectedPoints) + parseFloat(i.pointValue * i.orderedQty)
						this.setState({
							selectedPoints : points.toFixed(2)
						})
					}else{
						let points = parseFloat(this.state.selectedPoints) - parseFloat(i.pointValue * i.orderedQty)
						this.setState({
							selectedPoints : points.toFixed(2)
						})
					}
				}
			});
		});
		if (!e.target.checked) {
			self.setState({
				isSelectAll: false,
				errorMessage: '',
			});
		} else {
			self.setState({
				errorMessage: '',
			});
		}
		if (whichObject === 'backOrders') {
			self.props.saveBackOrders(payload);
		} else {
			self.props.saveBulkOrdersHold(payload);
		}
	}

	handleKeepOriginalPrice(itemx, e) {
		const self = this;
		const payload = JSON.parse(JSON.stringify(self.props.state.order.backOrders));
		payload.responseObject.forEach((item, index) => {
			item.orderDetail.orderLine.forEach((i, index) => {
				if (i.orderLineId === itemx) {
					i.keepOriginalPrice = e.target.checked ? "Y" : "N";
				}
			});
		});
		self.props.saveBackOrders(payload);
	}

	handleKeepOriginalPO(itemx, whichObject, e) {
		const self = this;
		const payload = JSON.parse(JSON.stringify(self.props.state.order[whichObject]));
		payload.responseObject.forEach((item, index) => {
			item.orderDetail.orderLine.forEach((i, index) => {
				if (i.orderLineId === itemx) {
					i.keepOriginalPO = e.target.checked ? "Y" : "N";
				}
			});
		});
		if (whichObject === 'backOrders') {
			self.props.saveBackOrders(payload);
		} else {
			self.props.saveBulkOrdersHold(payload);
		}
	}

  	handleSelectAll(e) {
		const self = this;
		const backOrders = JSON.parse(JSON.stringify(self.props.state.order.backOrders));
		let selectAllPoints= 0;
		let multipliedValues =0;
		backOrders && backOrders.responseObject && backOrders.responseObject.forEach((item, index) => {
			item.orderDetail.orderLine.forEach((i, index) => {
				if (i.lineStatus.toLowerCase() !== 'cancelled' && self.props.isBackOrderHold(i) && i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
					if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y" && self.checkIfAnyFilterSatisfied(item, i)) {
						i.selected = e.target.checked;
					}
				}
				multipliedValues =  i.pointValue && parseFloat(i.pointValue*i.orderedQty)
				if(multipliedValues){
					selectAllPoints = selectAllPoints + multipliedValues
				}
			});
		});
		const bulkOrdersHold = JSON.parse(JSON.stringify(self.props.state.order.bulkOrdersHold));
		bulkOrdersHold && bulkOrdersHold.responseObject && bulkOrdersHold.responseObject.forEach(item => {
			if (self.props.isBulkOrderHold(item.orderHeader, item.orderDetail.orderLine)) {
				if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
					item.orderDetail.orderLine.forEach((i, index) => {
						if (i.lineStatus.toLowerCase() !== 'cancelled' && i.originalReservedQty > 0 && self.checkIfAnyFilterSatisfied(item, i)) {
							i.selected = e.target.checked;
						}
						multipliedValues =  i.pointValue && parseFloat(i.pointValue*i.reservedQty)
						if(multipliedValues){
						selectAllPoints = selectAllPoints + multipliedValues
							}
					});
				}
			}
		});
		self.setState({
			isSelectAll: !self.state.isSelectAll,
			errorMessage: '',
		});
		if(e.target.checked  && !self.state.filter.shipToAddress && !self.state.filter.salesAgreement ){
			self.setState({
				selectedPoints: selectAllPoints.toFixed(2)
			})
		}else if(e.target.checked && self.state.filter.shipToAddress || self.state.filter.salesAgreement  ){
			self.setState({
				selectedPoints: self.state.points
			})
		}else{
			self.setState({
				selectedPoints: 0.00,
				selectAllPoints:0.00
			})
		}
		self.props.saveBackOrders(backOrders);
		self.props.saveBulkOrdersHold(bulkOrdersHold);
	}

	handlePriceSourceDialog(selectedPriceSource, pricingDate, dialog, flag, selectedItem, e) {
		e.preventDefault();
		const self = this;
		let payload = {
			account_number: self.props.getSelectedAccountNumber(),
			pricing_effective_date: moment().tz('America/New_York').format('YYYYMMDD'),
			sa_number: selectedPriceSource,
			item_numbers: [selectedItem.item],
		};
		self.props.checkForPrices(payload, true, false, null, response => {
			let todaysPrice = '';
			if(response.responseObject && response.responseObject.items && response.responseObject.items.length > 0) {
				const item = response.responseObject.items[0];
				if (item.records && item.records.length && item.records[0].adjusted_unit_price) {
					todaysPrice = item.records[0].adjusted_unit_price
				}
			}
			// Make pricing service call to show today's price
			self.setState({
				selectedPriceSource,
				selectedItem: {
					...selectedItem,
					todaysPrice: todaysPrice || "Today's price not available currently."
				},
				orderDate: pricingDate,
			}, () => {
				self.handleDialog(dialog, flag, e);
			});
		});
	}

	handleMoveToCart(e) {
	    e.preventDefault();
	    const self = this;
	    let selectedCount = 0;
	    const selectedItems = [];
	    const cartItems = [];
    	const backOrders = JSON.parse(JSON.stringify(self.props.state.order.backOrders));
		let formError = false;
		const errorList = [];
		backOrders.responseObject.forEach((item, index) => {
			item.orderDetail.orderLine.forEach((i, index) => {
				if(i.orderedQtyError || i.orderedQtyRequiredError) {
					formError = true;
				}
				if (i.selected && self.checkIfAnyFilterSatisfied(item, i)) {
					i.orderNumber = item.orderHeader.orderNumber;
					i.buyerLineNo = i.keepOriginalPO === 'Y' ? i.buyerLineNum : '';
					i.orderDate = i.keepOriginalPrice === 'Y' ? self.props.pickTheDateFromString(i.linePricingDate) : '';
					i.agreementNumber = i.lineSANumber;
					i.orderLineId = i.orderLineId;
					i.poNumber = i.lineCustomerPONumber;
					i.quantity = i.orderedQty;
					selectedCount += 1;
					selectedItems.push(i);
				}
			});
		});
		self.props.saveBackOrders(backOrders);
		const bulkOrdersHold = JSON.parse(JSON.stringify(self.props.state.order.bulkOrdersHold));
		bulkOrdersHold.responseObject.forEach((item, index) => {
			item.orderDetail.orderLine.forEach((i, index) => {
				if(i.reservedQtyError || i.reservedQtyRequiredError) {
					formError = true;
				}
				if (i.selected && self.checkIfAnyFilterSatisfied(item, i)) {
					i.orderNumber = item.orderHeader.orderNumber;
					i.buyerLineNo = i.keepOriginalPO === 'Y' ? i.buyerLineNum : '';
					i.orderDate = i.keepOriginalPrice === 'Y' ? self.props.pickTheDateFromString(i.linePricingDate) : '';
					i.agreementNumber = i.lineSANumber;
					i.orderLineId = i.orderLineId;
					i.poNumber = i.lineCustomerPONumber;
					i.quantity = i.reservedQty;
					selectedCount += 1;
					selectedItems.push(i);
				}
			});
		});
		self.props.saveBulkOrdersHold(bulkOrdersHold);
		// Check if atlease one item is selected or not
		this.setState({
			errorMessage: "",
			errorList,
		}, () => {
			if(!selectedCount) {
				formError = true;
				this.setState({
					errorMessage: "Please select at least one item and try again.",
				});
			}
	    	if (!formError && errorList.length === 0) {
				// Fetch item description before adding to cart
				const items = selectedItems.map(item => item.item);
				self.props.getItemsSuggestionDetails(_.uniq(items), '&needAllItems=Y', (itemsDetails) => {
					const {
						selectedAccount,
						userDetails
					} = self.props.state.user;
					const oldCart = this.props.state.cart.cart.responseObject && this.props.state.cart.cart.responseObject.cartItems ? this.props.state.cart.cart.responseObject.cartItems : [];
		      		const product = [];
					oldCart.length > 0 && oldCart.forEach((item, index) => {
						product.push(item.item);
					});
					selectedItems.forEach((item, index) => {
						// pick description from getItems service response
						const itemDet = itemsDetails.find(itm => itm.sku === item.item);
						oldCart.push({
							...item,
							itemType: itemDet.itemType || item.itemType,
							itemDescription: itemDet ? itemDet.description : '',
							createdDate: moment().format(DATE_TIME_FORMAT),
							updatedDate: moment().format(DATE_TIME_FORMAT),
							imagePath:itemDet.imagePath
						});
					});
			      	oldCart.forEach((item, index) => {
						cartItems.push({
							itemType: !item.itemType || item.itemType === "" ? "M" : item.itemType,
							item: item.item,
							orderLineId: item.orderLineId,
							quantity: item.quantity,
							itemDescription: item.itemDescription,
							agreementNumber: item.agreementNumber,
							orderNumber: item.orderNumber,
							orderDate: item.orderDate,
							poNumber: item.poNumber,
							keepOriginalPrice: item.keepOriginalPrice,
							keepOriginalPO: item.keepOriginalPO,
							buyerLineNo: item.buyerLineNo,
							createdDate: item.createdDate,
							updatedDate: item.updatedDate,
							imagePath:item.imagePath
						});
		      		});
					this.props.addToCart({
						accountNumber: selectedAccount.ACCOUNTNUMBER,
						createdDate: moment().format("MM/DD/YYYY"),
						updatedDate: moment().format("MM/DD/YYYY"),
						userId: userDetails.sso,
						cartItems: cartItems,
					}, response => {
						// save backup of cart items for future reference to set keepOriginalPrice while moving from cart to create order
						let finalCartItems = response.responseObject.cartItems;
						let item = {};
						let cartItem = [];
						finalCartItems.forEach(itm => {
							item = {
								...itm,
								isBackOrder : true,

							}
							cartItem.push(item)
						})
						let finalResponse = {...response,responseObject : {cartItems:cartItem}}
						self.props.saveBackupCartItem(finalResponse);
						self.props.saveBackOrderCartItem(finalResponse);
						browserHistory.push('/cart');
					});
				});
			}
		});
	}

	handleChangeQuantity(orderNumberIndex, lineIndex, event) {
		const self = this;
		const backOrders = JSON.parse(JSON.stringify(self.props.state.order.backOrders));
		backOrders.responseObject.forEach((item, index) => {
			if(index === orderNumberIndex)
			item.orderDetail.orderLine.forEach((i, indx) => {
				if(lineIndex === indx) {
					let selectedOrderQty = i.orderedQty;
					i.orderedQty = event.target.value;
					if(event.target.value && parseInt(event.target.value, 10)) {
						if(parseInt(event.target.value, 10) > i.originalOrderQuantity) {
							i.orderedQtyError = 'error';
						} else {
							i.orderedQtyError = '';
						}
						i.orderedQtyRequiredError = '';
					} else {
						i.orderedQtyError = '';
						i.orderedQtyRequiredError = 'error';
					}
					if( i.selected && i.selected == true){
						if(i.orderedQty>selectedOrderQty){
							let points = parseFloat(this.state.selectedPoints) + parseFloat(i.pointValue * Math.abs(i.orderedQty-selectedOrderQty)) 
							this.setState({
								selectedPoints : points.toFixed(2)
							})
						}else if(i.orderedQty<selectedOrderQty){
							let points = parseFloat(this.state.selectedPoints) - parseFloat(i.pointValue * Math.abs(i.orderedQty-selectedOrderQty)) 
							this.setState({
								selectedPoints : points.toFixed(2)
							})
						}						
					}
				}
			});
		});
		self.props.saveBackOrders(backOrders);
	}

	handleChangeReservedQuantity(orderNumberIndex, lineIndex, event) {
		const self = this;
		const bulkOrdersHold = JSON.parse(JSON.stringify(self.props.state.order.bulkOrdersHold));
		bulkOrdersHold.responseObject.forEach((item, index) => {
			if(index === orderNumberIndex) {
				item.orderDetail.orderLine.forEach((i, indx) => {
					if(lineIndex === indx) {
						i.reservedQty = event.target.value;
						if(event.target.value && parseInt(event.target.value, 10)) {
							if(parseInt(event.target.value, 10) > i.originalReservedQty) {
								i.reservedQtyError = 'error';
							} else {
								i.reservedQtyError = '';
							}
							i.reservedQtyRequiredError = '';
						} else {
							i.reservedQtyError = '';
							i.reservedQtyRequiredError = 'error';
						}
					}
				});
			}
		});
		self.props.saveBulkOrdersHold(bulkOrdersHold);
	}

	updateFilterParam(event) {
		const self = this;
		self.setState({
			filter: {
				...self.state.filter,
				[event.target.name]: event.target.checked
			}
		}, () => {
			self.updateOrderPointsFilter();
		});
	}

	handleCancelLine(orderNumber, orderIndex, lineDetails, whichOrder, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			deletingItemDetails: {
				orderNumber,
				orderIndex,
				lineDetails,
				whichOrder
			}
		}, () => {
			self.handleDialog('ConfirmCancelLineOverlayDialog', true);
		});
	}

	cancelLine() {
		const self = this;
		const {
			orderNumber
		} = self.state.deletingItemDetails;
		self.handleDialog('ConfirmCancelLineOverlayDialog', false);
		let payload = self.props.getOrderDetailsFromParallelCall(orderNumber);
		// if data exists then use it else make call and then make delete service call
		if (payload) {
			self.makeCancelProductCall(payload);
		} else {
			self.props.getOrderDetailsInParallelBatches([orderNumber], () => {
				payload = self.props.getOrderDetailsFromParallelCall(orderNumber);
				self.makeCancelProductCall(payload);
			});
		}
	}

	makeCancelProductCall(payload) {
		const self = this;
		const {
			orderIndex,
			lineDetails,
			whichOrder
		} = self.state.deletingItemDetails;
		const { userDetails } = self.props.state.user;
		payload = JSON.parse(JSON.stringify(payload));
		payload.items = payload.items.filter(itm => itm.lineId.toString() === lineDetails.orderLineId.toString());
		payload.createdBy = userDetails.firstName + " " + userDetails.lastName;
		self.props.deleteOrderDetails(payload, 'requestType=cancelProducts', false, () => {
			// if(!response.status) {
			// 	self.setState({
			// 		errorMessage: response.responseMessage
			// 	});
			// } else if(!response.responseObject) {
			// 	self.setState({
			// 		genericDialogHeading: "Error",
			// 		genericDialogText: "Error occured while cancelling the order line.",
			// 		modalButtons: 'ok'
			// 	}, () => {
			// 		self.handleDialog("GenericOverlayDialog", true);
			// 	});
			// } else {
			// 	// Moved logic outside as we have to assume that service call will always success.
			// 	// reason behind showing success dialog immediately is, service is taking long time to finish
			// }
		});
		// remove that item from store so it will get removed from screen
		const { backOrders, bulkOrdersHold } = self.props.state.order;
		const orderList = whichOrder === 'backOrders' ? backOrders : bulkOrdersHold;
		orderList.responseObject[orderIndex].orderDetail.orderLine = orderList.responseObject[orderIndex].orderDetail.orderLine.filter(itm => itm.orderLineId.toString() !== lineDetails.orderLineId.toString());
		if (orderList.responseObject[orderIndex].orderDetail.orderLine.length === 0) {
			orderList.responseObject = orderList.responseObject.filter((itm, index) => index !== orderIndex);
		}
		const { saveBackOrders, saveBulkOrdersHold } = self.props;
		if(whichOrder === 'backOrders') {
			saveBackOrders(JSON.parse(JSON.stringify(orderList)));
		} else {
			saveBulkOrdersHold(JSON.parse(JSON.stringify(orderList)));
		}
	}

	checkIfAnyFilterSatisfied(item, line) {
		const self = this;
		const { orderHeader } = item;
		const { filter } = self.state;
		const selectedAgreementNumber = self.props.state.user.selectedPriceSource.AGREEMENT_NUMBER;
		let flag = false;
		if(!filter.salesAgreement && !filter.shipToAddress) {
			flag = true;
		} else if (!filter.shipToAddress && filter.salesAgreement) {
			flag = (line.lineSANumber === selectedAgreementNumber);
		} else if (!filter.salesAgreement && filter.shipToAddress && self.props.isOrderAddressSameAsHeader(orderHeader)) {
			flag = true;
		} else if (filter.salesAgreement && filter.shipToAddress && self.props.isOrderAddressSameAsHeader(orderHeader)) {
			flag = (line.lineSANumber === selectedAgreementNumber);
		}
		return flag;
	}

	render() {
		const self = this;
		const { backOrders, bulkOrdersHold } = self.props.state.order;
		const { points } = self.state;
		const isPricingAccess = self.props.isResponsibilityExists("Price");
		const editOrderAccess = this.props.isResponsibilityExists("Edit Orders");
    	return (
	      	<div>
	        	{backOrders && <div>
					<div>
						<h1 className="pageTitle">Backorders Available</h1>
						<div className="column column1 verticalAlignBottom textRight">
							{<a onClick={this.handleExport.bind(this)} className="withIcon withExportIcon noUnderline bold uppercase" href="">Export</a>}&nbsp;
							<span>{self.state.exportErrorMessage && <p  className="red">{self.state.exportErrorMessage}</p>}</span>
						</div>
						<div className="filter-wrapper">
							<p className="bold">Displaying ALL Backorders Available for Account { self.props.getSelectedAccountNumber() }</p>
							<div className="filter-container">
								<BackOrderFilters classname="backorder-filters" filter={this.state.filter} updateFilterParam={this.updateFilterParam.bind(this)} />
							</div>
						</div>
						<p className="clear"><strong>The following backorders are now available.</strong><br />Please take action before the backorder expiration date by moving these products to your cart where you can start a new order.</p>
					
					</div>
					<div>
						<div className="flex-container mb-1">
							<div className="flex-item p-xs">
								<a className="blueButton blockButton ws-nowrap" href="" onClick={e => this.handleMoveToCart(e)}>Move Selections to Cart</a>
								{ self.state.errorMessage && <p className="red bold">{self.state.errorMessage}</p>}
								{ self.state.errorList.length > 0 && <p className="red bold">{self.state.errorList.map(item => item)}</p>}
							</div>
							<div className="flex-item red">
								<p className="p--backorder-note">
									NOTE: Backorders may appear on this list for some time
									after they have been moved to another order and booked. DO
									NOT delete or reselect a backorder that you have recently
									moved to a new order.
								</p>
							</div>
						</div>
		                <div className="mb-1">
			                <input type="checkbox" name="chkSelectAll" value="1" id="chkSelectAll1" onClick={this.handleSelectAll} checked={self.state.isSelectAll} />
			                <label className="bold">{" "}Select ALL Available Products Below</label>
							&nbsp; &nbsp; &nbsp; <label  className="bold" style={{color:"red"}}>{`Selected Backorder Points : ${this.state.selectedPoints}`}</label>&nbsp; &nbsp; &nbsp;All Available Backorder Points: {points}
		                </div>
		                {backOrders && backOrders.responseObject && backOrders.responseObject.map((item, index) => {
							let displayOrder = false;
							if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
								item.orderDetail.orderLine.forEach((i, index) => {
									if (i.lineStatus.toLowerCase() !== 'cancelled' && self.props.isBackOrderHold(i) && i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
										if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y" && self.checkIfAnyFilterSatisfied(item, i)) {
											displayOrder = true;
										}
									}
								});
								if(!displayOrder) return null;
	                          	const orderDate = self.props.pickTheDateFromString(item.orderHeader.orderDate);
								return <div key={index + 100}>
								  	<div className="backorder-heading captionAboveTable" style={{ marginTop: 0 }}>
										<div className="bold address">
											{self.props.getAddressFromOrderHeader(item.orderHeader)}
										</div>
										<div className="bold">
											CSO (Order number): {item.orderHeader.orderNumber} &nbsp;
											&nbsp; Order Date: {orderDate} &nbsp;
											&nbsp; P.O. #&nbsp;{item.orderHeader.ponumber} &nbsp;
											&nbsp; Warehouse: {item.orderHeader.warehouse && item.orderHeader.warehouse.warehouseCode}
										</div>
									</div>
								  	<table className="dataTable manageOrdersBackordersTableWithCancel" width="100%">
		                                <thead>
											<tr>
			                                    <th>Move<br />to Cart</th>
			                                    <th>Product</th>
			                                    <th className="txt-ctr">Points<br />per Unit</th>
			                                    <th>Quantity<br />Ordered</th>
			                                    {isPricingAccess && <th>Original<br />Price</th>}
			                                    <th>Keep<br />Original<br />Price</th>
			                                    <th>Price<br />Info</th>
			                                    <th>Backorder<br />Expires</th>
			                                    <th>Keep<br />Original<br />PO</th>
												<th>ADC</th>
												<th></th>
											</tr>
		                                </thead>
		                                {item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0 && item.orderDetail.orderLine.map((i, indx) => {
											if(i.lineStatus.toLowerCase() === 'cancelled' || !self.props.isBackOrderHold(i)) return null;
		                                    if (i.backOrdNotifications && i.backOrdNotifications.backOrdNotification && i.backOrdNotifications.backOrdNotification.length > 0) {
												if (i.backOrdNotifications.backOrdNotification.slice(-1)[0].notificationFlag === "Y" && self.checkIfAnyFilterSatisfied(item, i)) {
													const pricingDate = self.props.pickTheDateFromString(i.linePricingDate);
			                                        return <tbody key={indx}>
			                                            <tr>
															<td>
																<input type="checkbox" name="chkAddCart" value="1" id="chkAddCart1" onClick={e => this.handleAddToCart(i.orderLineId, 'backOrders', e)} checked={i.selected} />
															</td>
															<td>{i.item}</td>
															<td className="txt-ctr">{i.pointValue}</td>
															<td>
																<input className={i.orderedQtyError || i.orderedQtyRequiredError} onChange={this.handleChangeQuantity.bind(this, index, indx)} type="text" value={i.orderedQty} onKeyPress={this.props.acceptNumbersOnly} style={{width: '50%', textAlign: 'center'}}/>
																{i.orderedQtyError && <p className="red">Quantity can not be greater than original quantity.</p>}
																{i.orderedQtyRequiredError && <p className="red">Please enter quantity greater than 0.</p>}
															</td>
															{isPricingAccess && <td>${i.itemPrice && i.itemPrice.salesPrice}</td>}
															<td>
			                                                	<input type="checkbox" name="chkOrigPrice" value="1" id="chkOrigPrice1" onClick={e =>this.handleKeepOriginalPrice(i.orderLineId, e)} checked={i.keepOriginalPrice === "Y"} />
			                                              	</td>
															{isPricingAccess && <td>
																<a className="priceSource m-auto" href="" onClick={this.handlePriceSourceDialog.bind(this, i.lineSANumber, pricingDate, "PriceSourceOverlayDialog", true, {redirectFrom: 'backorders', item: i.item})}>$</a>
															</td>}
															<td>
																<span className="red">
																	{i.lineDate}
																</span>
															</td>
															<td>
																<input type="checkbox" name="chkOrigPO" value="1" id="chkSelectAll1" onClick={e => this.handleKeepOriginalPO(i.orderLineId, 'backOrders', e)} checked={i.keepOriginalPO === "Y"} />
																<label htmlFor="chkOrigPO1">{" "}{i.lineCustomerPONumber}</label>
															</td>
															<td className="txt-ctr">{i.warehouse && i.warehouse.warehouseCode}</td>
															<td>
																{editOrderAccess && <a className="blueButton blockButton ws-nowrap" href="" onClick={this.handleCancelLine.bind(this, item.orderHeader.orderNumber, index, i, 'backOrders')}>Cancel</a>}
															</td>
			                                            </tr>
		                                          	</tbody>
												}
		                                    }
	                                    	return null;
	                                  	})}
		                              </table>
		                            </div>
		                          ;
								}
							return null;
	                    })}
						{self.state.isThereAnyBulkOrderHold && <h1 className="pageTitle">Bulk Hold Orders</h1>}
						{bulkOrdersHold && bulkOrdersHold.responseObject.map((item, index) => {
							if (self.props.isBulkOrderHold(item.orderHeader, item.orderDetail.orderLine)) {
								let displayOrder = false;
								if (item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0) {
									item.orderDetail.orderLine.forEach((i, index) => {
										if (!(i.lineStatus.toLowerCase() === 'cancelled' || !i.originalReservedQty) && self.checkIfAnyFilterSatisfied(item, i)) {
											displayOrder = true;
										}
									});
								}
								if(!displayOrder) return null;
	                          	const orderDate = self.props.pickTheDateFromString(item.orderHeader.orderDate);
								return <div key={index + 100}>
								  	<div className="backorder-heading captionAboveTable" style={{ marginTop: 0 }}>
										<div className="bold address">
											{self.props.getAddressFromOrderHeader(item.orderHeader)}
										</div>
										<div className="bold">
											CSO (Order number): {item.orderHeader.orderNumber} &nbsp;
											&nbsp; Order Date: {orderDate} &nbsp;
											&nbsp; P.O. #&nbsp;{item.orderHeader.ponumber} &nbsp;
											&nbsp; Warehouse: {item.orderHeader.warehouse && item.orderHeader.warehouse.warehouseCode}
										</div>
									</div>
								  	<table className="dataTable manageOrdersBackordersTableWithCancel" width="100%">
		                                <thead>
											<tr>
			                                    <th>Move<br />to Cart</th>
			                                    <th>Product</th>
			                                    <th className="txt-ctr">Points<br />per Unit</th>
			                                    <th>Quantity<br />Ordered</th>
												<th>Quantity<br />Reserved</th>
			                                    {isPricingAccess && <th>Original<br />Price</th>}
			                                    <th>Price<br />Info</th>
			                                    <th>Keep&nbsp;Original&nbsp;PO</th>
												<th></th>
											</tr>
		                                </thead>
		                                {item.orderDetail && item.orderDetail.orderLine && item.orderDetail.orderLine.length > 0 && item.orderDetail.orderLine.map((i, indx) => {
											if(i.lineStatus.toLowerCase() === 'cancelled' || !i.originalReservedQty || !self.checkIfAnyFilterSatisfied(item, i)) return null;
											const pricingDate = self.props.pickTheDateFromString(i.linePricingDate);
	                                        return <tbody key={indx}>
	                                            <tr>
													<td>
														<input type="checkbox" name="chkAddBCart" value="1" id="chkAddBCart1" onClick={e => this.handleAddToCart(i.orderLineId, 'bulkOrdersHold', e)} checked={i.selected} />
													</td>
													<td>{i.item}</td>
													<td className="txt-ctr">{i.pointValue}</td>
													<td>
														{i.orderedQty}
													</td>
													<td>
														<input className={i.reservedQtyError || i.reservedQtyRequiredError} onChange={this.handleChangeReservedQuantity.bind(this, index, indx)} type="text" value={i.reservedQty} onKeyPress={this.props.acceptNumbersOnly} style={{width: '50%', textAlign: 'center'}}/>
														{i.reservedQtyError && <p className="red">Reserved Quantity can not be greater than original reserved quantity.</p>}
														{i.reservedQtyRequiredError && <p className="red">Please enter reserved quantity greater than 0.</p>}
													</td>
													{isPricingAccess && <td>${i.itemPrice && i.itemPrice.salesPrice}</td>}
													{isPricingAccess && <td>
														<a className="priceSource m-auto" href="" onClick={this.handlePriceSourceDialog.bind(this, i.lineSANumber, pricingDate, "PriceSourceOverlayDialog", true, {redirectFrom: 'backorders', item: i.item})}>$</a>
													</td>}
													<td>
														<input type="checkbox" name="chkOrigPO" value="1" id="chkSelectAll1" onClick={e => this.handleKeepOriginalPO(i.orderLineId, 'bulkOrdersHold', e)} checked={i.keepOriginalPO === "Y"} />
														<label htmlFor="chkOrigPO1">{" "}{i.lineCustomerPONumber}</label>
													</td>
													<td>
														{editOrderAccess && <a className="blueButton blockButton ws-nowrap" href="" onClick={this.handleCancelLine.bind(this, item.orderHeader.orderNumber, index, i, 'bulkOrders')}>Cancel</a>}
													</td>
	                                            </tr>
                                          	</tbody>
	                                  	})}
	                              	</table>
	                            </div>
							}
							return null;
	                    })}
		                <div className="flex-container mb-1">
							<div className="flex-item p-xs">
								<a className="blueButton blockButton ws-nowrap" href="" onClick={e => this.handleMoveToCart(e)}>Move Selections to Cart</a>
							</div>
							<div className="flex-item red">
								<p className="p--backorder-note">
									NOTE: Backorders may appear on this list for some time
									after they have been moved to another order and booked. DO
									NOT delete or reselect a backorder that you have recently
									moved to a new order.
								</p>
							</div>
		                </div>
	              	</div>
            	</div>}
	        	{this.state.showPriceSourceOverlayDialog ? <PriceSourceOverlayDialog formatMoney={this.props.formatMoney} isResponsibilityExists={this.props.isResponsibilityExists} orderDate={this.state.orderDate} selectedAccountsAllPriceSources={this.props.state.user.selectedAccountsAllPriceSources} selectedItem={this.state.selectedItem} priceSource={this.state.selectedPriceSource} showDialog={true} handleDialog={this.handleDialog} typeOfAccount={this.props.getSelectedAccountType()} /> : null}
				{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showConfirmCancelLineOverlayDialog?<ConfirmCancelLineOverlayDialog handleDialog={this.handleDialog.bind(this)} handleCancel={this.cancelLine.bind(this)} showDialog={true} />:null}
			</div>
    	);
	}
}
const mapStateToProps = state => {
	return { state };
};

const mapDispatchToProps = dispatch => ({
	saveBackOrders: data => dispatch(saveBackOrders(data)),
	saveBackupCartItem: data => dispatch(saveBackupCartItem(data)),
	saveBackOrderCartItem: data => dispatch(saveBackOrderCartItem(data)),
	exportOrdersDetails: (payload, queryStringParams, callback) => dispatch(exportOrdersDetails(payload, queryStringParams, callback)),
	saveBulkOrdersHold: data => dispatch(saveBulkOrdersHold(data)),
	deleteOrderDetails: (payload, queryStringParams, showLoader, callback) => dispatch(deleteOrderDetails(payload, queryStringParams, showLoader, callback)),
	addToCart: (payload, callback) => dispatch(addToCart(payload, callback)),
	checkForPrices: (payload, showLoader, saveToStore, cartOrOrder, response) => dispatch(checkForPrices(payload, showLoader, saveToStore, cartOrOrder, response)),
});

BackOrders = connect(
	mapStateToProps,
	mapDispatchToProps,
)(BackOrders);

export default BackOrders;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/backOrders.js